
import DialogTemplate from '@/_components/dialog/template/template.vue'
import { getRequest, postRequest } from '@/plugins/api-axios'
import CompanyTreeX from '@/views/Project/ch/components/companyTreeX.vue'
import Contractors from '@/views/Project/ch/components/contractors.vue'
import AutocompleteCompany from '@/components/Autocomplete/company.vue'
import ProjectMixin from '@/_mixins/project'
import { deserialise, serialise } from 'kitsu-core'
import { debounce } from 'lodash'

export default {
    name: 'ContractorsDialog',
    mixins: [ProjectMixin],
    props: {
        props: Object,
    },
    components: {
        AutocompleteCompany,
        Contractors,
        CompanyTreeX,
        DialogTemplate,
    },
    provide() {
        return {
            hierarchyProvider: {
                addCompany: this.addCompany,
            },
        }
    },
    data() {
        return {
            contractors: [] as any[],
            hierarchy: null as any,
            isLoading: false,
            tree: [] as any[],
            worker: null as Worker | null,
            searchContractorToggle: false,
            addNewContractorToggle: false,
            companyList: {
                searchTerm: '',
                newCompany: null,
                isPending: false,
            },
            addContractorMenu: false,
            contractorMenuActivator: null as HTMLElement | null,
        }
    },
    methods: {
        showAutocompleteContractor(el: HTMLElement) {
            this.contractorMenuActivator = el
            this.addContractorMenu = false
            setTimeout(() => {
                this.addContractorMenu = true
            })
        },

        handleSearchContractorToggle() {
            this.searchContractorToggle = !this.searchContractorToggle
            if (!this.searchContractorToggle) {
                this.companyList.searchTerm = ''
                this.filterContractors()
            }
        },

        handleAddContractorToggle() {
            this.addNewContractorToggle = !this.addNewContractorToggle

            if (!this.addNewContractorToggle) {
                this.companyList.newCompany = null
            }
        },

        handleSearchTermChanged: debounce(function () {
            this.filterContractors()
        }, 500),
        filterContractors() {
            this.worker?.postMessage({
                type: 'filterContractor',
                payload: {
                    searchTerm: this.companyList.searchTerm,
                    tree: this.tree,
                },
            })
        },
        async addCompany(company, parentId?) {
            const payload = serialise('contractorHierarchyNode', {
                hierarchy: {
                    data: {
                        type: 'contractorHierarchy',
                        id: this.hierarchy.id,
                    },
                },
                company: {
                    data: {
                        type: 'company',
                        id: company.id,
                    },
                },
                ...(parentId && {
                    parent: {
                        data: {
                            type: 'contractorHierarchyNode',
                            id: parentId,
                        },
                    },
                }),
            })

            await postRequest(
                this.getURL({ path: 'contractorHierarchyNodes', base: this.contractorBaseUrl }),
                {},
                payload.data
            )
            await this.getCompanyHierarchy()
            this.companyList.newCompany = null
            this.companyList.isPending = false
            this.addContractorMenu = false
        },
        async getCompanyHierarchy(firstLoad = false) {
            try {
                this.isLoading = firstLoad

                const hierarchyResponse = await getRequest(
                    this.getURL({
                        path: `contractorHierarchies/${this.currentProjectId}`,
                        base: this.contractorBaseUrl,
                        params: {
                            include: 'nodes,nodes.parent,nodes.company,nodes.companyDetails',
                            skipLinks: '',
                        },
                    })
                )

                let hierarchyData = deserialise(hierarchyResponse.data)
                this.hierarchy = hierarchyData.data

                let ids = {}
                let companyDetails = {}
                let tree: any[] = []
                hierarchyData.data.nodes.data.forEach((node) => {
                    ids[node.id] = { ...node, children: [] }
                    if (node.companyDetails?.data?.id) {
                        companyDetails[node.companyDetails.data.id] = node.id
                    }
                })
                hierarchyData.data.nodes.data.forEach((node) => {
                    const addingNode = ids[node.id]
                    addingNode._isMatch = !node.isArchived
                    if (!node.parent.data) {
                        tree.push(addingNode)
                    } else {
                        ids[node.parent.data.id].children.push(addingNode)
                        ids[node.parent.data.id].children.sort((a, b) => a.index - b.index)
                    }
                })
                this.tree = tree
            } catch (e) {
                console.error(e)
            } finally {
                this.isLoading = false
            }
        },
    },

    async created() {
        if (this.props.contractor) {
            this.contractors = [this.props.contractor]
            this.contractors[0].id = this.props.contractor._id || this.props.contractor.id
        }

        this.getCompanyHierarchy(true)
    },
}
